import React from 'react'

const activity = () => {
  return (
    <div>
      activity
    </div>
  )
}

export default activity
